import { render, staticRenderFns } from "./ArticleTrend.vue?vue&type=template&id=93823cc6&"
import script from "./ArticleTrend.vue?vue&type=script&lang=js&"
export * from "./ArticleTrend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports